import { render, staticRenderFns } from "./getIdentity.vue?vue&type=template&id=0acc9ec6&scoped=true&"
import script from "./getIdentity.vue?vue&type=script&lang=js&"
export * from "./getIdentity.vue?vue&type=script&lang=js&"
import style0 from "./getIdentity.vue?vue&type=style&index=0&id=0acc9ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc9ec6",
  null
  
)

export default component.exports